(function() {
  'use strict';

  /*global addToCartModalCtrl:true */

  angular.module('eclipseApp.checkout').factory('cartManager', [
    '$rootScope',
    'uteModal',
    '$q',
    '$state',
    '$http',
    'uteEndpoint',
    'env',
    'buyService',
    'notifier',
    '$translate',
    'uteLocale',
    'samKeyService',
    '$timeout',
    '$window',
    'brtSwitchCMS',
    function(
      $rootScope,
      uteModal,
      $q,
      $state,
      $http,
      uteEndpoint,
      env,
      buyService,
      notifier,
      $translate,
      uteLocale,
      samKeyService,
      $timeout,
      $window,
      brtSwitchCMS
    ) {
      var cartManager = {
        /**
         *
         */
        STATUS: {
          N_A: 'N_A',
          AVAILABLE: 'AVAILABLE',
          SELECTED: 'SELECTED',
          IN_CART: 'IN_CART',
          REMOVED: 'REMOVED'
        },

        /**
         *
         */
        EVENTS: {
          ADDED_TO_CART: 'ADDED_TO_CART',
          REMOVE_FROM_CART: 'REMOVE_FROM_CART',
          CART_CLEARED: 'CART_CLEARED'
        },

        // get total quantity
        getQuantity: function() {
          // console.log('getQuantitygetQuantitygetQuantity', $rootScope.shoppingCart, $rootScope.shoppingCart ? $rootScope.shoppingCart.quantity : 0, this.getQuantity.caller);
          return $rootScope.shoppingCart && $rootScope.shoppingCart.quantity ? $rootScope.shoppingCart.quantity : 0;
        },

        // validate the cart
        validate: function() {
          var deferred = $q.defer();

          $http({
            url: uteEndpoint('shoppingCart'),
            method: 'POST',
            params: {
              actionType: 'validateCart',
              userId: $rootScope.atg.userId.value,
              samKey: $rootScope.userPref.samKey,
              hashKey: $rootScope.atg.hashKey.value
            }
          }).then(
            function(data) {
              deferred.resolve(data);
            },
            function(data) {
              deferred.reject();
            }
          );

          return deferred.promise;
        },

        // clean all cart items
        cleanCart: function(silent, duplicateError) {
          var deferred = $q.defer();

          if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
            var emptyCart = {
              data: {
                shoppingCart: {
                  quantity: 0,
                  error: null,
                  agent: null,
                  province: 'ON',
                  timestamp: null,
                  en: null,
                  fr: null,
                  total: {
                    sub: null,
                    tax: null,
                    grand: null
                  },
                  userId: {
                    name: '',
                    value: '',
                    expire: ''
                  },
                  hashKey: {
                    name: '',
                    value: '',
                    expire: ''
                  }
                }
              }
            };
            $rootScope.shoppingCart = emptyCart.data.shoppingCart;
            buyService.deleteSession(['profile'], { force: true });
            deferred.resolve(emptyCart);
          } else {
            // only do if cart is not empty
            if (this.getQuantity() > 0 || duplicateError === true) {
              $http({
                url: uteEndpoint('shoppingCart'),
                //url: 'http://10.16.88.67:9000/selfserve/shoppingCart',
                method: 'POST',
                params: {
                  actionType: 'clean',
                  province: uteLocale.province,
                  samKey: $rootScope.userPref.samKey
                },
                cache: false
              }).then(
                function(result) {
                  // check if clean should be quiet -- don't update $rootScope.shoppingCart on success (mainly for province change pre-req)
                  if (angular.isUndefined(silent) || silent === false) {
                    $rootScope.shoppingCart = result.data.shoppingCart;
                  }

                  // TODO
                  // should clean checkout session
                  buyService.deleteSession(['profile'], { force: true });

                  deferred.resolve(result);
                },
                function() {
                  deferred.reject();
                }
              );
            } else {
              deferred.resolve({});
            }
          }

          return deferred.promise;
        },

        // modify root or service sub-object; add
        addMeta: function(props, serviceName) {
          var deferred = $q.defer();

          // reject if shoppingCart doesn't exist
          if (!$rootScope.shoppingCart) {
            deferred.reject();
          }

          // extend the shopping cart
          if (serviceName) {
            _.extend($rootScope.shoppingCart[uteLocale.language].services[serviceName], props);

            // check if passed prop has been added
            if (_.isMatch($rootScope.shoppingCart[uteLocale.language].services[serviceName], props)) {
              deferred.resolve(true);
            } else {
              deferred.reject();
            }
          } else {
            _.extend($rootScope.shoppingCart, props);

            if (_.isMatch($rootScope.shoppingCart, props)) {
              deferred.resolve(true);
            } else {
              deferred.reject();
            }
          }

          return deferred.promise;
        },

        // modify root or service sub-object; remove
        removeMeta: function(propertyName, serviceName) {
          var deferred = $q.defer();

          // reject if shoppingCart doesn't exist
          if (!$rootScope.shoppingCart) {
            deferred.reject();
          }

          // remove from the shopping cart; service/root
          if (serviceName) {
            $rootScope.shoppingCart[uteLocale.language].services[serviceName] = _.omit(
              $rootScope.shoppingCart[uteLocale.language].services[serviceName],
              propertyName
            );
            deferred.resolve(true);
          } else {
            $rootScope.shoppingCart = _.omit($rootScope.shoppingCart, propertyName);
            deferred.resolve(true);
          }

          return deferred.promise;
        },

        // wireless methods
        wireless: {
          get: {
            cartQuantity: function() {
              // check if there's anything for the wireless cart
              if ($.cookie('itemsInCart') && $.cookie('itemsInCart') > 0) {
                return $.cookie('itemsInCart');
              }
              return 0;
            }
          }
        },

        // all internet services
        internet: {
          stockInternetTierToCart: function(shoppingCart) {
            // for demo purpose, uncomment the following line, then comment all the remaining lines in stockInternetTierToCart function.
            //$rootScope.shoppingCart = { en : { services : { internet : shoppingCart}}};
            $rootScope.shoppingCart = shoppingCart;
            if (
              $rootScope.shoppingCart &&
              $rootScope.shoppingCart[uteLocale.language] &&
              $rootScope.shoppingCart[uteLocale.language].services &&
              $rootScope.shoppingCart[uteLocale.language].services.internet &&
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier &&
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier.length > 0 &&
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].products &&
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].products.length > 0
            ) {
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].selectedOffer =
                $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].products[0].offers[0];
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].selectedOffer.tierId =
                $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].tierId;
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].selectedOffer.productId =
                $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].products[0].id;
            }
          },

          getCartSummary: function(techInstall) {
            var currentCart = $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0];
            var selectedOffer = currentCart.selectedOffer;
            var cartSummary = {
              orderSummaryTotal: {
                monthly: {
                  tax: 0,
                  total: selectedOffer.offerPrice.price, // if tech install, add prices together
                  offerTotal: selectedOffer.offerPrice.price,
                  subTotal: selectedOffer.offerPrice.price
                },
                oneTime: {
                  subTotal: 0
                }
              },
              products: {
                internet: {
                  subTotal: selectedOffer.offerPrice.price
                }
              }
            };

            if (techInstall) {
              cartSummary.orderSummaryTotal.monthly.offerTotal = selectedOffer.offerPrice.priceWithInstallation;
              cartSummary.orderSummaryTotal.monthly.total = selectedOffer.offerPrice.priceWithInstallation;
              cartSummary.orderSummaryTotal.oneTime.subTotal = selectedOffer.offerPrice.installationFee;
            }
            return cartSummary;
          },

          // returns tier that's already in cart
          tierInCart: function() {
            // console.log('GETTINGTIERINCARTxxxxx', cartManager.getQuantity(), $rootScope.shoppingCart);

            if (
              cartManager.getQuantity() > 0 &&
              $rootScope.shoppingCart &&
              $rootScope.shoppingCart[uteLocale.language] &&
              $rootScope.shoppingCart[uteLocale.language].services &&
              $rootScope.shoppingCart[uteLocale.language].services.internet &&
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier &&
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier.length > 0
            ) {
              var currentCart = $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0];
              // console.log('GETTINGTIERINCART', currentCart, currentCart.selectedOffer);
              if (currentCart.selectedOffer) {
                /*if (currentCart.selectedOffer.discounts && currentCart.selectedOffer.discounts.length > 0) {
                  if (currentCart.selectedOffer.packagePrice &&
                    currentCart.selectedOffer.packagePrice.promotionalPrice &&
                    $rootScope.shoppingCart.total && currentCart.selectedOffer.packagePrice.promotionalPrice != $rootScope.shoppingCart.total.sub
                  ) {
                    cartManager.addMeta({ total: {
                          tax: $rootScope.shoppingCart.total.tax,
                          grand: currentCart.selectedOffer.packagePrice.promotionalPrice,
                          sub: currentCart.selectedOffer.packagePrice.promotionalPrice
                        }
                      })
                      .then(function() {
                        console.log('sub', $rootScope.shoppingCart);
                      });
                  }
                }*/
                return currentCart;
              } else if (currentCart.products && currentCart.products.length > 0) {
                currentCart.offers = [];
                for (var i = 0, product; (product = currentCart.products[i]); i++) {
                  for (var j = 0, offer; (offer = product.offers[j]); j++) {
                    offer.productId = product.id;
                    offer.tierId = currentCart.tierId;
                    currentCart.offers.push(offer);
                  }
                }
                currentCart.selectedOffer = currentCart.offers[0];
                /*if (
                  currentCart.selectedOffer &&
                  currentCart.selectedOffer.discounts &&
                  currentCart.selectedOffer.discounts.length > 0
                ) {
                  if (
                    currentCart.selectedOffer.packagePrice &&
                    currentCart.selectedOffer.packagePrice.promotionalPrice &&
                    $rootScope.shoppingCart.total &&
                    currentCart.selectedOffer.packagePrice.promotionalPrice != $rootScope.shoppingCart.total.sub
                  ) {
                    cartManager
                      .addMeta({
                        total: {
                          tax: $rootScope.shoppingCart.total.tax,
                          grand: currentCart.selectedOffer.packagePrice.promotionalPrice,
                          sub: currentCart.selectedOffer.packagePrice.promotionalPrice
                        }
                      })
                      .then(function() {
                        console.log('sub', $rootScope.shoppingCart);
                      });
                  }
                }*/
                return currentCart;
              }

              return false;
            }

            return false;
          },

          // swap internet offers
          swapOffers: function(tierIdIn, productIdIn, offerIn, tierIdOut, productIdOut, offerOut, externalIdArray) {
            var deferred = $q.defer();
            var paramsRequest = {};
            if (externalIdArray.length > 0) {
              paramsRequest = {
                actionType: 'addAndRemove',
                province: uteLocale.province,
                samKey: $rootScope.userPref.samKey,
                tierIdIn: tierIdIn,
                productIdIn: productIdIn,
                offerIdIn: offerIn,
                tierIdOut: tierIdOut,
                productIdOut: productIdOut,
                offerIdOut: offerOut,
                userId: $rootScope.atg.userId.value,
                hashKey: $rootScope.atg.hashKey.value,
                discountId: externalIdArray
              };
            } else {
              paramsRequest = {
                actionType: 'addAndRemove',
                province: uteLocale.province,
                samKey: $rootScope.userPref.samKey,
                tierIdIn: tierIdIn,
                productIdIn: productIdIn,
                offerIdIn: offerIn,
                tierIdOut: tierIdOut,
                productIdOut: productIdOut,
                offerIdOut: offerOut,
                userId: $rootScope.atg.userId.value,
                hashKey: $rootScope.atg.hashKey.value
              };
            }
            uteModal
              .processRequest({
                request: {
                  url: uteEndpoint('shoppingCart'),
                  //url: 'http://10.16.88.67:9000/selfserve/shoppingCart',
                  method: 'POST',
                  data: paramsRequest,
                  cache: false
                }
              })
              .then(
                function(result) {
                  if (result.shoppingCart.error && result.shoppingCart.error === '60016') {
                    _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                    _satellite.track('bfa-fhsi-error');
                    $translate('global.error.inline.cart.genericTitle').then(function(title) {
                      $translate('global.error.inline.cart.genericMessage').then(function(message) {
                        notifier.notify.info({ title: title, desc: message });
                      });
                    });
                  } else {
                    cartManager.internet.stockInternetTierToCart(result.shoppingCart);
                    buyService.resetStep('fulfillment');
                    deferred.resolve(result);
                    console.log(buyService.isTypeOfFulfillmentSelected());
                  }
                },
                function() {
                  deferred.reject();
                  _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                  _satellite.track('bfa-fhsi-error');
                  $translate('global.error.inline.cart.genericTitle').then(function(title) {
                    $translate('global.error.inline.cart.genericMessage').then(function(message) {
                      notifier.notify.info({ title: title, desc: message });
                    });
                  });
                }
              );

            return deferred.promise;
          },

          // remove offer from cart
          removeOffer: function(tierId, productId, offerId) {
            var deferred = $q.defer(),
              modalConfig = {
                templateUrl: 'views/templates/modal/remove-from-cart.html',
                controller: /* @ngInject */ [
                  '$scope',
                  '$modalInstance',
                  function($scope, $modalInstance) {
                    $scope.service = 'internet';
                    $scope.ok = function() {
                      $modalInstance.close();
                    };

                    $scope.cancel = function() {
                      $modalInstance.dismiss('cancel');
                    };
                  }
                ],
                ok: function() {
                  uteModal
                    .processRequest({
                      request: {
                        url: uteEndpoint('shoppingCart'),
                        method: 'POST',
                        params: {
                          actionType: 'remove',
                          province: uteLocale.province,
                          samKey: $rootScope.userPref.samKey,
                          tierId: tierId,
                          productId: productId,
                          offerId: offerId,
                          userId: $rootScope.atg.userId.value,
                          hashKey: $rootScope.atg.hashKey.value
                        },
                        cache: false
                      }
                    })
                    .then(
                      function(result) {
                        if (result.shoppingCart && result.shoppingCart.error && result.shoppingCart.error === '60016') {
                          _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                          _satellite.track('bfa-fhsi-error');
                          $translate('global.error.inline.cart.genericTitle').then(function(title) {
                            $translate('global.error.inline.cart.genericMessage').then(function(message) {
                              notifier.notify.info({ title: title, desc: message });
                            });
                          });
                        } else {
                          cartManager.internet.stockInternetTierToCart(result.shoppingCart);
                          deferred.resolve(result);
                          console.log(buyService.isTypeOfFulfillmentSelected());
                        }
                      },
                      function() {
                        deferred.reject();
                        $translate('global.error.inline.cart.genericTitle').then(function(title) {
                          $translate('global.error.inline.cart.genericMessage').then(function(message) {
                            notifier.notify.info({ title: title, desc: message });
                          });
                        });
                      }
                    );
                },
                cancel: function() {}
              };

            // show modal
            uteModal.open(modalConfig);

            return deferred.promise;
          },

          // add offer to the cart
          addOffer: function(tier, offerInContext) {
            var deferred = $q.defer(),
              tempTier = tier,
              selectedTierId = tier.tierId;
            var externalIdArray = [];
            if (tier.selectedOffer && tier.selectedOffer.discounts && tier.selectedOffer.discounts.length > 0) {
              for (var iLoop = 0; iLoop < tier.selectedOffer.discounts.length; iLoop++) {
                if (tier.selectedOffer.discounts[iLoop].externalId) {
                  externalIdArray.push(tier.selectedOffer.discounts[iLoop].externalId);
                }
              }
            }

            if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
              var lang = uteLocale.language;
              var tempShoppingCart = {
                quantity: 1,
                total: {
                  sub: 0,
                  tax: 0,
                  grand: 0
                },
                userId: {
                  name: '',
                  value: '',
                  expire: ''
                },
                hashKey: {
                  name: '',
                  value: '',
                  expire: ''
                }
              };
              tempShoppingCart[lang] = {
                services: {
                  internet: {
                    quantity: 1,
                    total: null,
                    tier: [tempTier]
                  },
                  wireless: null
                }
              };

              cartManager.internet.stockInternetTierToCart(tempShoppingCart);
              deferred.resolve(tempShoppingCart);
              $window.sessionStorage.setItem(
                'agentSelectedOffer',
                JSON.stringify({
                  tierId: selectedTierId,
                  offerInContext: offerInContext
                })
              );
            } else {
              // first check if max quantity for service reached; if so, confirm with user to swap offers

              if (cartManager.maxItemsInCart('internet')) {
                var tierInCart = this.tierInCart();

                var modalConfig = {
                  oldPackage: tierInCart.selectedOffer.name,
                  newPackage: tempTier.selectedOffer.name,
                  controller: /* @ngInject */ [
                    '$scope',
                    '$modalInstance',
                    'oldPackage',
                    'newPackage',
                    function($scope, $modalInstance, oldPackage, newPackage) {
                      $scope.ok = function() {
                        $modalInstance.close();
                      };

                      $scope.cancel = function() {
                        $modalInstance.dismiss('cancel');
                      };

                      $scope.oldPackage = oldPackage;

                      $scope.newPackage = newPackage;
                    }
                  ],
                  templateUrl: 'modules/checkout/views/add-to-cart.html',
                  ok: function() {
                    cartManager.internet
                      .swapOffers(
                        tempTier.selectedOffer.tierId,
                        tempTier.selectedOffer.productId,
                        tempTier.selectedOffer.offerId,
                        tierInCart.selectedOffer.tierId,
                        tierInCart.selectedOffer.productId,
                        tierInCart.selectedOffer.offerId,
                        externalIdArray
                      )
                      .then(function() {
                        $state.go('cartSummary');
                      });
                  },
                  cancel: function() {
                    deferred.reject();
                  }
                };

                // show modal
                uteModal.open(modalConfig);
              } else {
                var paramsRequest = {};
                if (externalIdArray.length > 0) {
                  paramsRequest = {
                    actionType: 'add',
                    province: uteLocale.province,
                    samKey: $rootScope.userPref.samKey,
                    tierId: tier.selectedOffer.tierId,
                    productId: tier.selectedOffer.productId,
                    offerId: tier.selectedOffer.offerId,
                    userId: $rootScope.atg.userId.value,
                    hashKey: $rootScope.atg.hashKey.value,
                    discountId: externalIdArray
                  };
                } else {
                  paramsRequest = {
                    actionType: 'add',
                    province: uteLocale.province,
                    samKey: $rootScope.userPref.samKey,
                    tierId: tier.selectedOffer.tierId,
                    productId: tier.selectedOffer.productId,
                    offerId: tier.selectedOffer.offerId,
                    userId: $rootScope.atg.userId.value,
                    hashKey: $rootScope.atg.hashKey.value
                  };
                }
                uteModal
                  .processRequest({
                    request: {
                      url: uteEndpoint('shoppingCart'),
                      method: 'POST',
                      data: paramsRequest,
                      cache: false,
                      closeOnError: true
                    }
                  })
                  .then(
                    function(result) {
                      if (
                        result.shoppingCart &&
                        result.shoppingCart.error &&
                        result.shoppingCart.error.toString() === '60016'
                      ) {
                        _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                        _satellite.track('bfa-fhsi-error');
                        $translate('global.error.inline.cart.genericTitle').then(function(title) {
                          $translate('global.error.inline.cart.genericMessage').then(function(message) {
                            notifier.notify.info({ title: title, desc: message });
                          });
                        });
                      } else if (
                        result.shoppingCart &&
                        result.shoppingCart.error &&
                        result.shoppingCart.error.toString() === '60025'
                      ) {
                        _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                        _satellite.track('bfa-fhsi-error');
                        deferred.reject(result.shoppingCart.error.toString());
                        // samKeyService.showAvailabilityModal('internet', tier, 'cartSummary');
                        $timeout(function() {
                          samKeyService.showAvailabilityModal('internet', null, 'cartSummary');
                        }, 500);
                      } else {
                        cartManager.internet.stockInternetTierToCart(result.shoppingCart);
                        deferred.resolve(result);
                        console.log(buyService.isTypeOfFulfillmentSelected());
                      }
                    },
                    function() {
                      deferred.reject();
                      _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                      _satellite.track('bfa-fhsi-error');
                      $translate('global.error.inline.cart.genericTitle').then(function(title) {
                        $translate('global.error.inline.cart.genericMessage').then(function(message) {
                          notifier.notify.info({ title: title, desc: message });
                        });
                      });
                    }
                  );
              }
            }

            return deferred.promise;
          }
        },

        iptv: {
          stockIptvToCart: function(shoppingCart) {
            $rootScope.shoppingCart = shoppingCart;
            var lang = uteLocale.language;

            if (cartManager.iptv.isTvPackageInCart(lang) === true) {
              var tvCategory = $rootScope.shoppingCart[lang].services.tv.tvCategories[0];
              tvCategory.selectedOffer = tvCategory.products[0].tvOffers[0];
              tvCategory.selectedOffer.offerId = tvCategory.products[0].tvOffers[0].offerId;
              tvCategory.selectedOffer.offerName = tvCategory.products[0].tvOffers[0].name;
              tvCategory.selectedOffer.alaCartes = cartManager.iptv.getAlaCartesFromCart(lang);
              tvCategory.selectedOffer.themePacks = cartManager.iptv.getThemePacksFromCart(lang);
              tvCategory.selectedOffer.allChannels = cartManager.iptv.listAllChannels(shoppingCart, lang);
            }
          },
          listAllChannels: function(shoppingCart, lang) {
            var allChannels = [],
              basicChannels = [],
              mandatoryChannels = [],
              flexChannels = [],
              swapChannels = [],
              alaCarteChannels = [],
              themePackChannels = [];
            var offer = shoppingCart[lang].services.tv.tvCategories[0].selectedOffer;

            if (offer.channels && offer.channels.basic) {
              basicChannels = _.map(offer.channels.basic, function(channel) {
                var list = {};
                list.category = 'p';
                list.ttCode = channel.ttCode;
                list.sku = channel.channelId;
                list.name = channel.name;
                return list;
              });
            }

            if (offer.channels && offer.channels.mandatory) {
              mandatoryChannels = _.map(offer.channels.mandatory, function(channel) {
                var list = {};
                list.category = 'p';
                list.ttCode = channel.ttCode;
                list.sku = channel.channelId;
                list.name = channel.name;
                return list;
              });
            }

            if (offer.channels && offer.channels.flex) {
              flexChannels = _.map(offer.channels.flex, function(channel) {
                var list = {};
                list.category = 'p';
                list.ttCode = channel.ttCode;
                list.sku = channel.channelId;
                list.name = channel.name;
                return list;
              });
            }

            if (offer.channels && offer.channels.swap) {
              swapChannels = _.map(offer.channels.swap, function(channel) {
                var list = {};
                list.category = 's';
                list.ttCode = channel.ttCode;
                list.sku = channel.channelId;
                list.name = channel.name;
                return list;
              });
            }

            if (offer.alaCartes !== null) {
              alaCarteChannels = _.map(offer.alaCartes, function(channel) {
                var list = {};
                list.category = 'a';
                list.ttCode = channel.ttCode;
                list.sku = channel.channelId;
                list.name = channel.name;
                return list;
              });
            }

            allChannels = _.union(basicChannels, mandatoryChannels, flexChannels, swapChannels, alaCarteChannels);
            console.log('All Channels', allChannels);
            return allChannels;
          },
          isTvPackageInCart: function(lang) {
            if (
              cartManager.getQuantity() > 0 &&
              $rootScope.shoppingCart &&
              $rootScope.shoppingCart[lang] &&
              $rootScope.shoppingCart[lang].services &&
              $rootScope.shoppingCart[lang].services.tv &&
              $rootScope.shoppingCart[lang].services.tv.tvCategories &&
              $rootScope.shoppingCart[lang].services.tv.tvCategories.length > 0 &&
              $rootScope.shoppingCart[lang].services.tv.tvCategories[0].products &&
              $rootScope.shoppingCart[lang].services.tv.tvCategories[0].products.length > 0 &&
              $rootScope.shoppingCart[lang].services.tv.tvCategories[0].products[0].tvOffers &&
              $rootScope.shoppingCart[lang].services.tv.tvCategories[0].products[0].tvOffers.length > 0
            ) {
              return true;
            } else {
              return false;
            }
          },
          isAlaCarteInCart: function(lang) {
            if (
              cartManager.getQuantity() > 0 &&
              $rootScope.shoppingCart &&
              $rootScope.shoppingCart[lang] &&
              $rootScope.shoppingCart[lang].services &&
              $rootScope.shoppingCart[lang].services.tv &&
              $rootScope.shoppingCart[lang].services.tv.additionalOptions &&
              $rootScope.shoppingCart[lang].services.tv.additionalOptions.alaCartes &&
              $rootScope.shoppingCart[lang].services.tv.additionalOptions.alaCartes.length > 0
            ) {
              return true;
            } else {
              return false;
            }
          },
          isThemePackInCart: function(lang) {
            if (
              cartManager.getQuantity() > 0 &&
              $rootScope.shoppingCart &&
              $rootScope.shoppingCart[lang] &&
              $rootScope.shoppingCart[lang].services &&
              $rootScope.shoppingCart[lang].services.tv &&
              $rootScope.shoppingCart[lang].services.tv.tvCategories &&
              $rootScope.shoppingCart[lang].services.tv.additionalOptions.length > 0 &&
              $rootScope.shoppingCart[lang].services.tv.additionalOptions.themePacks &&
              $rootScope.shoppingCart[lang].services.tv.additionalOptions.themePacks.length > 0
            ) {
              return true;
            } else {
              return false;
            }
          },
          isChannelInCart: function(lang, sku, returnType) {
            if (cartManager.iptv.isTvPackageInCart(lang) === true) {
              var selectedOffer = cartManager.iptv.getTvPackageFromCart(lang);
              if (selectedOffer.allChannels) {
                var allChannels = selectedOffer.allChannels;
              } else {
                var allChannels = cartManager.iptv.listAllChannels($rootScope.shoppingCart, lang);
                $rootScope.shoppingCart[lang].services.tv.tvCategories[0].selectedOffer.allChannels = allChannels;
              }
              var pos = _.find(allChannels, function(channel) {
                return channel.sku === sku;
              });
              if (pos !== undefined) {
                if (returnType === true) {
                  return pos.category;
                }
                return true;
              }
              return false;
            }
          },
          getChannelTypeInCart: function(lang, sku) {
            return cartManager.iptv.isChannelInCart(lang, sku, true);
          },
          isSkuInCart: function() {
            return false;
          },
          isChannelInThemePack: function() {
            return false;
          },
          isThemePackContainExistingChannel: function() {
            return false;
          },
          getTvPackageFromCart: function(lang) {
            if (cartManager.iptv.isTvPackageInCart(lang)) {
              return $rootScope.shoppingCart[lang].services.tv.tvCategories[0].selectedOffer;
            } else {
              return null;
            }
          },
          getAlaCartesFromCart: function(lang) {
            if (cartManager.iptv.isAlaCarteInCart(lang)) {
              return $rootScope.shoppingCart[lang].services.tv.additionalOptions.alaCartes;
            } else {
              return null;
            }
          },
          getThemePacksFromCart: function(lang) {
            if (cartManager.iptv.isThemePackInCart(lang)) {
              return $rootScope.shoppingCart[lang].services.tv.additionalOptions.themePacks;
            } else {
              return null;
            }
          },
          // add iptv offer to the cart
          addOffer: function(selectedOffer, productId, flexChannelIds, swappedChannelSkus, samKey) {
            var deferred = $q.defer();

            //first check if max quantity for service reached; if so, confirm with user to swap offers
            if (cartManager.maxItemsInCart('tv')) {
              var lang = uteLocale.language;
              var currentOffer = cartManager.iptv.getTvPackageFromCart(lang);

              var modalConfig = {
                oldPackage: 'package with offer ' + currentOffer.offerName,
                newPackage: 'package with offer ' + selectedOffer.name,
                controller: /* @ngInject */ [
                  '$scope',
                  '$modalInstance',
                  'oldPackage',
                  'newPackage',
                  function($scope, $modalInstance, oldPackage, newPackage) {
                    $scope.ok = function() {
                      $modalInstance.close();
                    };

                    $scope.cancel = function() {
                      $modalInstance.dismiss('cancel');
                    };

                    $scope.oldPackage = oldPackage;

                    $scope.newPackage = newPackage;
                  }
                ],
                templateUrl: 'modules/checkout/views/add-to-cart.html',
                ok: function() {
                  cartManager.iptv
                    .swapOffers(selectedOffer.offerId, flexChannelIds, currentOffer.offerId, swappedChannelSkus)
                    .then(function() {
                      $state.go('cartSummary');
                    });
                },
                cancel: function() {}
              };

              // show modal
              uteModal.open(modalConfig);
            } else {
              uteModal
                .processRequest({
                  request: {
                    url: uteEndpoint('iptvShoppingCart'),
                    method: 'POST',
                    data: {
                      actionType: 'add',
                      province: uteLocale.province,
                      samKey: samKey,
                      userId: $rootScope.atg.userId.value,
                      hashKey: $rootScope.atg.hashKey.value,
                      swappedChannelSkus: swappedChannelSkus,
                      productId: productId,
                      offerId: selectedOffer.offerId
                    },
                    cache: false
                  }
                })
                .then(
                  function(result) {
                    var response = cartManager.handleShoppingCartResponse(deferred, result, 'iptv', null);
                    //Item already exists in shopping cart, handle duplicate package by fetch cart
                    //If same package, show user message that package exists in cart
                    //If new package, call addPackage again
                    if (response === '60020') {
                      cartManager.handelDuplicatePackage(
                        selectedOffer,
                        productId,
                        flexChannelIds,
                        swappedChannelSkus,
                        samKey,
                        lang
                      );
                    }
                  },
                  function(error) {
                    _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                    _satellite.track('bfa-fhsi-error');
                    cartManager.handleShoppingCartError(deferred, error, 'iptv');
                  }
                );
            }
            return deferred.promise;
          },

          // remove iptv offer from cart
          removeOffer: function(offerId) {
            var deferred = $q.defer(),
              modalConfig = {
                templateUrl: 'views/templates/modal/remove-from-cart.html',
                controller: /* @ngInject */ [
                  '$scope',
                  '$modalInstance',
                  function($scope, $modalInstance) {
                    $scope.service = 'iptv';

                    $scope.ok = function() {
                      $modalInstance.close();
                    };

                    $scope.cancel = function() {
                      $modalInstance.dismiss('cancel');
                    };
                  }
                ],
                ok: function() {
                  uteModal
                    .processRequest({
                      request: {
                        url: uteEndpoint('shoppingCart'),
                        method: 'POST',
                        params: {
                          actionType: 'remove',
                          province: uteLocale.province,
                          samKey: $rootScope.userPref.samKey,
                          offerId: offerId,
                          userId: $rootScope.atg.userId.value,
                          hashKey: $rootScope.atg.hashKey.value
                        },
                        cache: false
                      }
                    })
                    .then(
                      function(result) {
                        cartManager.handleShoppingCartResponse(deferred, result, 'iptv', null);
                      },
                      function(error) {
                        _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                        _satellite.track('bfa-fhsi-error');
                        cartManager.handleShoppingCartError(deferred, error, 'iptv');
                      }
                    );
                },
                cancel: function() {}
              };

            // show modal
            uteModal.open(modalConfig);

            return deferred.promise;
          },

          // swap iptv offers
          swapOffers: function(offerIn, flexChannelsIn, offerOut, swappedChannelSkus) {
            var deferred = $q.defer();
            uteModal
              .processRequest({
                request: {
                  url: uteEndpoint('iptvShoppingCart'),
                  //url: 'http://10.16.88.67:9000/selfserve/shoppingCart',
                  method: 'POST',
                  data: {
                    actionType: 'addAndRemove',
                    province: uteLocale.province,
                    samKey: $rootScope.userPref.samKey,
                    userId: $rootScope.atg.userId.value,
                    hashKey: $rootScope.atg.hashKey.value,
                    offerId: offerIn,
                    swappedChannelSkus: swappedChannelSkus,
                    offerIdsOut: offerOut
                  },
                  cache: false
                }
              })
              .then(
                function(result) {
                  cartManager.handleShoppingCartResponse(deferred, result, 'iptv', 'fulfillment');
                },
                function(error) {
                  _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                  _satellite.track('bfa-fhsi-error');
                  cartManager.handleShoppingCartError(deferred, error, 'iptv');
                }
              );
            return deferred.promise;
          },

          // add optional items to shopping cart for iptv
          addOptionalItemsToCart: function(offerIn, optionalSkus, optionalQty) {
            var deferred = $q.defer();
            var optionalSkusAndQuantity = {};
            optionalSkusAndQuantity[optionalSkus] = optionalQty.toString();
            uteModal
              .processRequest({
                request: {
                  url: uteEndpoint('iptvShoppingCart'),
                  method: 'POST',
                  data: {
                    actionType: 'addOptional',
                    province: uteLocale.province,
                    samKey: $rootScope.userPref.samKey,
                    userId: $rootScope.atg.userId.value,
                    hashKey: $rootScope.atg.hashKey.value,
                    offerId: offerIn,
                    optionalSkusAndQuantity: optionalSkusAndQuantity
                  },
                  cache: false
                }
              })
              .then(
                function(result) {
                  cartManager.handleShoppingCartResponse(deferred, result, 'iptv', null);
                },
                function(error) {
                  cartManager.handleShoppingCartError(deferred, error, 'iptv');
                }
              );
            return deferred.promise;
          },

          // add optional items to shopping cart for iptv
          removeOptionalItemsFromCart: function(offerId, optionalSkus) {
            var deferred = $q.defer();
            var skus = [];
            skus.push(optionalSkus);
            uteModal
              .processRequest({
                request: {
                  url: uteEndpoint('iptvShoppingCart'),
                  method: 'POST',
                  data: {
                    actionType: 'removeOptional',
                    province: uteLocale.province.toUpperCase(),
                    samKey: $rootScope.userPref.samKey,
                    userId: $rootScope.atg.userId.value,
                    hashKey: $rootScope.atg.hashKey.value,
                    offerId: offerId,
                    channelSkus: skus
                  },
                  cache: false
                }
              })
              .then(
                function(result) {
                  cartManager.handleShoppingCartResponse(deferred, result, 'iptv', null);
                },
                function(error) {
                  _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                  _satellite.track('bfa-fhsi-error');
                  cartManager.handleShoppingCartError(deferred, error, 'iptv');
                }
              );
            return deferred.promise;
          }
        },
        handelDuplicatePackage: function(selectedOffer, productId, flexChannelIds, swappedChannelSkus, samKey, lang) {
          cartManager.cleanCart(true, true).then(function() {
            cartManager.iptv
              .addOffer(selectedOffer, productId, flexChannelIds, swappedChannelSkus, samKey)
              .then(function() {});
          });
          //cartManager.fetch();
          //if (cartManager.iptv.getTvPackageFromCart(lang).offerId === selectedOffer.offerId) {
          //  $translate('Duplicate Item').then(function (title) {
          //    $translate('This item already exists in cart. Please either remove this item or try adding another item.').then(function (message) {
          //      notifier.notify.info({title: title, desc: message});
          //    });
          //  });
          //}
          //else {
          //  cartManager.iptv.addOffer(selectedOffer, productId, flexChannelIds, swappedChannelSkus, samKey);
          //}
        },
        handleShoppingCartResponse: function(deferred, result, service, step) {
          if (result.shoppingCart.error && result.shoppingCart.error === '60016') {
            _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
            _satellite.track('bfa-fhsi-error');
            cartManager.handleShoppingCartError(deferred, result.shoppingCart.error, service);
          } else if (result.shoppingCart.error && result.shoppingCart.error === '60020') {
            //60020 means cart already has existing iptv offer and we are sending another offer
            //We need to send add and remove option to handle this, so first fetch the cart
            //then add
            return '60020';
          } else {
            if (service === 'iptv') {
              cartManager.iptv.stockIptvToCart(result.shoppingCart);
              deferred.resolve(result);
            }
            if (step === 'fulfillment') {
              buyService.resetStep('fulfillment');
            }
          }
        },

        handleShoppingCartError: function(deferred, error, service) {
          deferred.reject();
          $translate('global.error.inline.cart.genericTitle').then(function(title) {
            $translate('global.error.inline.cart.genericMessage').then(function(message) {
              notifier.notify.info({ title: title, desc: message });
            });
          });
        },

        // fetch shopping cart data
        fetch: function() {
          // do fetch only if userId and hashKey are not 'default'
          var deferred = $q.defer();
          if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
            var emptyCart = {
              data: {
                shoppingCart: {
                  quantity: 0,
                  error: null,
                  agent: null,
                  province: 'ON',
                  timestamp: null,
                  en: null,
                  fr: null,
                  total: {
                    sub: null,
                    tax: null,
                    grand: null
                  },
                  userId: {
                    name: '',
                    value: '',
                    expire: ''
                  },
                  hashKey: {
                    name: '',
                    value: '',
                    expire: ''
                  }
                }
              }
            };
            deferred.resolve(emptyCart);
          } else {
            $http({
              url: uteEndpoint('shoppingCart'),
              method: 'POST',
              params: {
                actionType: 'fetch',
                province: uteLocale.province,
                samKey: $rootScope.userPref.samKey,
                userId: $rootScope.atg.userId.value,
                hashKey: $rootScope.atg.hashKey.value,
                auid: $rootScope.userPref.auId
              },
              cache: false
            }).then(
              function(result) {
                cartManager.internet.stockInternetTierToCart(result.data.shoppingCart);
                cartManager.iptv.stockIptvToCart(result.data.shoppingCart);
                deferred.resolve(result);
              },
              function(data) {
                deferred.reject();
              }
            );
          }

          return deferred.promise;
        },

        /**
         *
         * @param status
         * @returns {boolean}
         */
        statusSelected: function(status) {
          return angular.isUndefined(status) ? false : angular.stringContains(status, cartManager.STATUS.SELECTED);
        },

        /**
         *
         * @param status
         * @returns {boolean}
         */
        statusInCart: function(status) {
          return angular.isUndefined(status) ? false : angular.stringContains(status, cartManager.STATUS.IN_CART);
        },

        /**
         *
         * @param status
         * @returns {boolean}
         */
        statusAvailable: function(status) {
          return angular.isUndefined(status) ? false : angular.stringContains(status, cartManager.STATUS.AVAILABLE);
        },

        /**
         * check to see if the offer exists anywhere throughout the shopping cart
         * @param tier
         * @param service
         * @returns {boolean}
         */
        //isAddedToCart: function (tier, service) {
        //
        //  var inCart = false,
        //    serviceAvailable,
        //    shoppingCart,
        //    currentService;
        //
        //  if (angular.isUndefinedOrNull($rootScope.shoppingCart) || angular.isUndefinedOrNull(tier.selectedOffer) || angular.isUndefinedOrNull($rootScope.shoppingCart[uteLocale.language]) || angular.isUndefinedOrNull($rootScope.shoppingCart[uteLocale.language].services)) {
        //    return inCart;
        //  }
        //
        //  //console.log('isAddedToCart', tier);
        //
        //  currentService = $rootScope.shoppingCart[uteLocale.language].services[service];
        //
        //  _.some(currentService.tier, function (shoppingCartItem) {
        //
        //    _.some(shoppingCartItem.offers, function (offerInCart, index) {
        //
        //      if (!angular.isUndefinedOrNull(tier.selectedOffer) && tier.selectedOffer.offerId === offerInCart.offerId && tier.tierId === shoppingCartItem.tierId) {
        //        inCart = true;
        //        return true;
        //      }
        //
        //    });
        //
        //  });
        //
        //  return inCart;
        //
        //},

        // returns boolean based on whether max has been reached for a service
        maxItemsInCart: function(service) {
          var max = {
            internet: 1,
            tv: 1
          };

          var lang = uteLocale.language;

          if (cartManager.getQuantity() > 0) {
            if (
              $rootScope.shoppingCart &&
              $rootScope.shoppingCart[lang] &&
              $rootScope.shoppingCart[lang].services &&
              $rootScope.shoppingCart[lang].services[service]
            ) {
              console.log('rootScope cart quantity', $rootScope.shoppingCart[lang].services[service].quantity);
              return $rootScope.shoppingCart[lang].services[service].quantity >= max[service];
            }
          }
          return false;
        }
      };

      return cartManager;
    }
  ]);
})();
